import { createBaseAction } from '@essent/common';
import type { GetDynamicPricesResponse } from '@integration/api-client/tariffmanagement';

import type { ChangeDatePayload } from '../models';
import type { EnergyType } from '../../shared/api-client-interfaces';

export const initDynamicPrices = createBaseAction(
  '[Dynamic Prices] Init Dynamic prices'
);

export const updateDynamicPrices = createBaseAction(
  '[Dynamic Prices] Update Dynamic prices'
);

export const changeSelectedDate = createBaseAction<ChangeDatePayload>(
  '[Dynamic Prices] Change selected date'
);

export const updateEnergyType = createBaseAction<EnergyType>(
  '[Dynamic Prices] Update energy type'
);

export const setQueryParams = createBaseAction<EnergyType | null>(
  '[Dynamic Prices] Set query params'
);

export const setSelectedEnergyType = createBaseAction<EnergyType>(
  '[Dynamic Prices] Set selected energy type'
);

export const setSelectedDate = createBaseAction<string>(
  '[Dynamic Prices] Set selected date'
);

export const setSelectedActionId = createBaseAction<string>(
  '[Dynamic Prices] Set selected actionId'
);

export const setSelectedHour = createBaseAction<number>(
  '[Dynamic Prices] Set selected hour'
);

export const setDynamicPricesSuccess =
  createBaseAction<GetDynamicPricesResponse>(
    '[Dynamic Prices] Set dynamic prices response'
  );
